import { useEffect } from "react";

/*
 * Mobile card tables, app-wide: stamps each <td> with a data-label taken from
 * its column header so the CSS in index.css can render rows as stacked cards
 * (no horizontal scrolling) on small screens. Runs once, watches the DOM.
 */
export default function TableCardify() {
    useEffect(() => {
        let scheduled = false;
        const stamp = () => {
            scheduled = false;
            document.querySelectorAll("table.dense-table").forEach((tb) => {
                const ths = Array.from(tb.querySelectorAll(":scope > thead th")).map((th) => (th.textContent || "").trim());
                tb.querySelectorAll(":scope > tbody > tr").forEach((tr) => {
                    Array.from(tr.children).forEach((td, i) => {
                        if (td.getAttribute("colspan")) { td.removeAttribute("data-label"); return; }
                        const label = ths[i];
                        if (label) {
                            if (td.getAttribute("data-label") !== label) td.setAttribute("data-label", label);
                        } else {
                            td.removeAttribute("data-label");
                        }
                    });
                });
            });
        };
        const schedule = () => {
            // setTimeout, not requestAnimationFrame — rAF can be throttled to a
            // standstill in background/embedded tabs and labels would never stamp.
            if (!scheduled) { scheduled = true; setTimeout(stamp, 50); }
        };
        stamp();
        const mo = new MutationObserver(schedule);
        mo.observe(document.body, { childList: true, subtree: true });
        return () => mo.disconnect();
    }, []);
    return null;
}
